<div class="features">
  <div class="feature">
    <img src="../../assets/img/feature-export-gold.png" alt="feature">
    <h2>Feature Name</h2>
    <p>Feature description Feature description Feature description </p>
  </div>
  <div class="feature">
    <img src="../../assets/img/feature-export-gold.png" alt="feature">
    <h2>Feature Name</h2>
    <p>Feature description</p>
  </div>
  <div class="feature">
    <img src="../../assets/img/feature-export-gold.png" alt="feature">
    <h2>Feature Name</h2>
    <p>Feature description</p>
  </div>
  <div class="feature">
    <img src="../../assets/img/feature-export-gold.png" alt="feature">
    <h2>Feature Name</h2>
    <p>Feature description</p>
  </div>
  <div class="feature">
    <img src="../../assets/img/feature-export-gold.png" alt="feature">
    <h2>Feature Name</h2>
    <p>Feature description</p>
  </div>
  <div class="feature">
    <img src="../../assets/img/feature-export-gold.png" alt="feature" width="100px">
    <h2>Feature Name</h2>
    <p>Feature description</p>
  </div>
</div>
